<!-- 自定义缴费批次 添加/编辑 -->
<template>
  <el-dialog
    class="batch-pay-model-dialog"
    :title="`${preTitle}${title}批次`"
    :visible.sync="show"
    :close-on-click-modal="false"
    :before-close="close"
    width="520px"
  >
    <el-form ref="form" :model="formData" :rules="rules" label-width="120px">
      <el-form-item prop="batchName" label="名称">
        <el-input v-model.trim="formData.batchName" />
      </el-form-item>
      <el-form-item label="缴费模式" prop="dailyPayTypeId">
        <span v-if="!!id">{{batchTypeMap[+formData.batchType||1].label}}</span>
          <el-radio-group v-else v-model="formData.batchType" :disabled="!!id" @change="formData.dailyPayTypeId=null">
            <el-radio-button v-for="(item) in Object.values(batchTypeMap)" :key="item.value" :label="+item.value">{{item.label}}</el-radio-button>
          </el-radio-group>
      </el-form-item>
      <!-- 缴费类型 自定义项目 显示  -->
      <el-form-item label="绑定缴费类型" prop="dailyPayTypeId">
        <tool-tips-group is-flex :tips-content="`1.当选择“跟类型缴费”时，费用数据来源于“${title}-缴费类型弹窗”。<br/>2.当选择“自定义缴费”时，费用数据将根据导入的学生信息进行获取。`">
          <el-select v-model="formData.dailyPayTypeId" clearable :disabled="!!id">
            <el-option
              v-for="{name,amount,id} in PayTypeList"
              :label="`${name}${formData.batchType===1?'（金额'+amount+'）':''}`"
              :value="id"
              :key="id" />
          </el-select>
        </tool-tips-group>
      </el-form-item>
      <el-form-item label="过期时间" prop="expiredTime">
        <el-date-picker
          type="datetime"
          placeholder="过期时间"
          v-model="formData.expiredTime"
          style="width: 100%"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm:00"
        />
      </el-form-item>
      <el-form-item prop="remarks" label="备注">
        <el-input v-model.trim="formData.remarks" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save(`${title}批次`,saveBatchPayModelApi)">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import dialog from '@/vue/mixins/dialog'
import { listDailyPayTypeApi } from '@/api/finance-manage/pay-type-api'
import { getBatchPayModelByIdApi, saveBatchPayModelApi } from '@/api/finance-manage/custom-pay-api'

export default {
  name: 'batchPayModelDialog',
  mixins: [dialog],
  props: {
    orgaType: String
  },
  inject: ['batchTypeMap'],
  data () {
    return {
      PayTypeList: [],
      formData: {
        id: null,
        batchName: '',
        batchType: '',
        dailyPayTypeId: null,
        expiredTime: '',
        remarks: '',
        orgaType: 'zhxy' // zhxy-自定义缴费批次(财务处); yuanwei-专升本缴费(招生办)
      },
      rules: {
        batchName: [this.$store.state.commonValidate.limit30WordsObj,
          {
            required: true,
            message: '请填写缴费批次的名称',
            trigger: 'blur'
          }],
        batchType: {
          required: true,
          message: '请选择缴费模式',
          trigger: 'blur'
        },
        dailyPayTypeId: {
          required: true,
          message: '请选择要绑定的缴费类型',
          trigger: 'blur'
        },
        expiredTime: {
          required: true,
          message: '请选择过期时间',
          trigger: 'blur'
        }
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.title = this.orgaType === 'zhxy' ? '自定义缴费' : '专升本缴费'
      this.getDailyTradeTypeList()
      if (this.id) {
        this.getDataById(this.id, getBatchPayModelByIdApi)
      } else {
        this.formData.orgaType = this.orgaType
      }
    })
  },
  methods: {
    saveBatchPayModelApi, // 保存api
    // 日常费用 的缴费类型  type=2 自定义
    async getDailyTradeTypeList () {
      if (this.PayTypeList.length) return
      try {
        const _type = this.orgaType === 'zhxy' ? '2' : '3'
        const res = await listDailyPayTypeApi(_type)
        this.PayTypeList = res.data
      } catch (e) {
      }
    }
  }
}
</script>
